// Every gameplay number lives here. Lengths are fixed point (ONE = 1 unit),
// speeds per tick (120 ticks/s), damping as keep-per-tick out of 4096.
import { ONE } from './num.js';

const u = v => Math.round(v * ONE);

export const TUNE = {
  crabR: u(0.5),
  littleR: u(0.3),
  wakeR: u(0.5) + 700,        // wake disc is a touch wider than the shell so it seals against the rim
  maxSpeed: 751,              // ~22 u/s; below every radius per tick, so nothing tunnels
  minSpeed: 140,
  minPower: 60,               // per mille; below this a release cancels
  keep: 4064,
  kelpKeep: 3930,
  littleKeep: 4030,
  friction: 1,
  stopSpeed: 10,
  swimSpeed: 44,
  rimRestitution: 780,
  rockRestitution: 820,
  bodyRestitution: 900,
  littleRestitution: 600,
  soundMin: 24,
  selfGap: 24,                // own wake younger than this many ticks is not a crossing
  crossCooldown: 18,
  fillEvery: 4,
  maxTicks: 840,
  bossInk: u(1.0),
  bossExtraSpread: 0,
  bossCalmPermille: 340,      // the nushi calms once its water is down to about a third of the pool
  quickenEvery: 3,            // +1 undertow ring per turn after every 3 turns in the same pool
  // Tonight's rules
  currentPush: 40,            // current: carries a moving body ~40/4096 unit per tick (~1.2 u/s)
  calmKeep: 4071,             // calm sea: crabs glide a little further
  logKeep: 3990,              // driftwood is heavy and stops soon
  logR: u(0.55),
  vortexR: u(0.55),
  rivalR: u(0.5),
  pearlR: u(0.18),
  bloomWake: 1200,            // per mille wake width on a bloom night
  hornStep: 30,               // per mille added to the nushi's calm line per triton hit
  hornMax: 90,
  // Games of the night
  lanternSpeed: 128,          // lanterns drift toward the outlet each turn
  lanternKeep: 4072,
  floatR: u(0.36),
  floatKeep: 4068,
  netR: u(1.15),
  exitR: u(2.0),
  stencilGoal: 800,           // per mille of the picture to light
  starPenMax: 180,            // cells: a pen bigger than this washes a star out
};

export const CRABS = [
  { id: 'goro', shell: 'sazae' },
  { id: 'bou', shell: 'horagai' },
  { id: 'chika', shell: 'takaragai' },
  { id: 'mio', shell: 'tsumetagai' },
];

export const LITTLE_KINDS = ['fry', 'takoko', 'seahorse', 'fugu'];

// Tide of the night (from the real moon) -> how the night plays.
export const TIDES = {
  oshio:    { turns: 17, spread: 3, seeps: 4, littles: [5, 7], boss: true,  twist: null },
  nakashio: { turns: 16, spread: 3, seeps: 4, littles: [4, 6], boss: true,  twist: null },
  koshio:   { turns: 14, spread: 2, seeps: 3, littles: [4, 5], boss: false, twist: null },
  nagashio: { turns: 16, spread: 2, seeps: 4, littles: [4, 6], boss: false, twist: null },      // slack tide (prefers the kelp rule)
  wakashio: { turns: 15, spread: 3, seeps: 3, littles: [4, 6], boss: false, twist: null },      // turning tide (prefers the swift rule)
};

export const POOLS_PER_NIGHT = 3;

// Per game of the night: undertow speed and seeps on top of the tide's.
export const MODE_TUNE = {
  pen: { spread: 0, seeps: 0, turns: 0 },
  stars: { spread: 1, seeps: 0, turns: 1 },
  lantern: { spread: 0, seeps: -1, turns: 4 },
  floats: { spread: 0, seeps: -1, turns: 5 },      // the undertow is what carries floats, so it keeps its speed
  picture: { spread: 1, seeps: 0, turns: -1 },
};
